import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }  from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { InvoicesRebComponent } from './invoices-reb.component';
import { InvoicesRebFiltersComponent } from './invoices-filters/invoices-reb-filters.component';

import { InvoiceRebService } from './invoice-reb.service';
import { ListInvoiceRebService } from './list.service';

import { AngularMaterialModule } from '../angular-material.module';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  providers: [
    InvoicesRebFiltersComponent,
    ListInvoiceRebService,
    InvoiceRebService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ],
  declarations: [
    InvoicesRebComponent,
    InvoicesRebFiltersComponent
  ],
  exports: [
    InvoicesRebComponent
  ]
})
export class InvoicesRebModule { }
